import { render, staticRenderFns } from "./take-order-pay.vue?vue&type=template&id=1b5c7a6e&scoped=true&"
import script from "./take-order-pay.vue?vue&type=script&lang=js&"
export * from "./take-order-pay.vue?vue&type=script&lang=js&"
import style0 from "./take-order-pay.vue?vue&type=style&index=0&id=1b5c7a6e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c7a6e",
  null
  
)

export default component.exports